import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import { Typography, Grid } from '@material-ui/core';
import styled from '../utils/styled';
import Section from '../components/Section';
import Page from '../components/Page';
import PaperContainer from '../components/PaperContainer';
import featureImage from './iStock_000039752072_Full.jpg';

const content = (
  <div>
    <PaperContainer>
      Home Care Plus offers a wide variety of care options to individuals or couples. Our home care services are flexible and customized to meet your changing needs.
    </PaperContainer>
    <PaperContainer headerText="Numerous Benefits" >
      <ul style={{ margin: '0 0 0 20px', padding: 0 }}>
        <li>Friendly companionship</li>
        <li>Mobility assistance</li>
        <li>Cooking and meal preparation</li>
        <li>Bathing, dressing and toileting</li>
        <li>Light housekeeping</li>
        <li>Errands and shopping</li>
        <li>Medication reminders</li>
      </ul>
    </PaperContainer>
    <PaperContainer headerText="Arrangement of appointments" >
      <ul style={{ margin: '0 0 0 20px', padding: 0 }}>
        <li>Transportation to church or synagogue, appointments</li>
        <li>Social events</li>
        <li>Hospital concierge service</li>
        <li>Assistance with pet care</li>
        <li>Airline departure/arrival assistance</li>
      </ul>
    </PaperContainer>
  </div>
);

const Services = ({ data }) => {
  return (
    <Section>
      <Grid item xs={12} sm={8}>
        <Helmet title="Services - Home Care Plus" />
        <Page
          image={featureImage}
          title={"Services"}
        >
          { content }
        </Page>
      </Grid>
    </Section>
  );
};
export default Services;



// WEBPACK FOOTER //
// ./src/pages/services.js